export default "__VITE_ASSET__DhhB77Bc__"